<div style="padding:2rem;" class="test-view">
  <h2>Buttons:</h2>
  <div style="border: 1px solid green; padding: 2px;"
  class="row-layout">
    <app-delete-document></app-delete-document>
    <app-download-document></app-download-document>
    <app-email-dialog-button></app-email-dialog-button>
    <app-print-document></app-print-document>
    <app-view-document [data]="{canview:true}"></app-view-document>
  </div>
</div>
